import {Component} from '../../core';
import {CoworkHomeContactComponent} from './cowork-home-contact.component'; 
import {CoworkDynamicContactComponent} from './cowork-dynamic-contact.component'; 
import {getLoggedInUser} from '../../loginService'
import {isEmpty,getterSetter,replaceSpace, connectionCheck} from '../../utils/common';
import {addPageView} from './coworkga';
import {adServicesInit} from '../../services/adServices'
import {initForum} from '../../services/forum';


/**
 * Cowork component
 */
export class CoworkVapComponent extends Component {

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        // Initialize the contact form
        this.initializeContactForm();

        this.initializeContactsEvent();

        // Initialize the featured spaces
        this.initializeNearByPlaces();

        getLoggedInUser.then((result) => {
            if(result && result.data && result.data.user){
                getterSetter.set( 'loginData', result);
                getterSetter.set( 'loginstatus', true);
            }else{
                getterSetter.set( 'loginstatus', false);
            }
            return true;
        });


        if(connectionCheck()){
            adServicesInit();
            var targetNode = document.getElementById('coworkvap_1');
            if(targetNode){
               if(targetNode.children){
                    if(document.getElementById('mHeaderAPI')){
                        document.getElementById('mHeaderAPI').classList.add('dfp_slot')
                    }
                    if(document.getElementById('dHeaderAPI')){
                        document.getElementById('dHeaderAPI').classList.add('dfp_slot')
                    }
                }
            }
        }

         // console.log(globals, ' globals');
        //Init Forum..
        initForum(globals.Id,'cowork');

        // Initialize page view
        this.initializePageView();
    }

    /**
     * Initializes  page view
     */
    initializePageView() {
        let property = globals.coworkProperty;
        let cityName = globals.coworkCity;
        let locality = globals.coworkLocality;
        let url = '/VAP?catname=QH_CoWork';
        if(!isEmpty(property)){
            url += '&Property='+replaceSpace(property);
        }
        if(!isEmpty(cityName)){
            url += '&City='+replaceSpace(cityName);
        }
        if(!isEmpty(locality)){
            url += '&Locality='+replaceSpace(locality);
        }
        url += ',v72=True';
        addPageView(url);
    }

    /**
     *  Initialize POIs
     */
    initializeNearByPlaces() {
        
        // Render the top pois 
        let post = {
            'entityType': 'cowork',
            'entityId': globals.coworkPropertyId,
            'count': 1,
            'top': 12,
            'source':0
        };
        let postData = new FormData();
        postData.append("nearByPlaces", JSON.stringify( post ))
        fetch('/coworking/nearByPlaces', {
            method : 'POST',
            body : postData
        }).then(function(res){
            return res.text();
        }).then(function(data){
            if(!isEmpty(data)){
               let val = data.replace(/(\r\n|\n|\r)/gm, "");
               val = val.replace('[]', "");
                if(!isEmpty(val) && val.length > 0 && val.trim() != '0'){
                    document.getElementById('nearByLandmarks').innerHTML = val;
                }else{
                    document.getElementById('nearByLandmarksSection').classList.add('hide');
                }
            }else{
                document.getElementById('nearByLandmarksSection').classList.add('hide');
            }
       });

    }

    /**
     * Initializes the contact form
     */
    initializeContactForm() {
        const contactComponent = new CoworkHomeContactComponent();

        //Init Formtwo
        contactComponent.on('formTwo', () => {
            this.refs.detailFormBtn.click();
            this.initializeDetailForm();
        });
    }

    /**
     * Initializes the extra detail modal component
     */
    initializeDetailForm() {
        const contactComponent = new CoworkHomeDetailComponent();
    }

    /**
     * Initializes the contact form
     */
    initializeContactsEvent() {
        
        var classname = document.getElementsByClassName("enquiryinit");
        Array.from(classname).forEach((element) => {
          element.addEventListener('click', this.initializeContactFormWithPropertyId.bind(this));
        });
    }

    initializeContactFormWithPropertyId(ev) {
        document.getElementById('co_workEnquiryPopup').innerHTML = '';
        // Initialize the contact form
        this.fetchContact().then((response) => {
            document.getElementById('co_workEnquiryPopup').innerHTML = response;
            let propertyId = ev.target.getAttribute("data-ref-id");
            let propertyDetail = ev.target.getAttribute("data-ref-leaddetail");
            if(document.getElementById('contactDynamicFormId')) {
                document.getElementById('contactDynamicFormId').setAttribute('data-component', 'cowork-dynamic-contact' + propertyId);
            }
            const contactComponent = new CoworkDynamicContactComponent(null, {propertyId, propertyDetail});
        });
    }

    fetchContact() {
        return fetch(`/homes/re2/coworkcontact?aj=1`).then((res) => res.text());
    }
}
